import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SalaryTwoResponseDto, SalaryTwoUpsertRequest } from '../../models/api/companySalaryTwoDto';
import { YearlyResource } from '../../models/api/yearlyResource';

@Injectable({
  providedIn: 'root'
})
export class CompanySalaryTwoService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  getSalaryTwo(companyId: string, year?: number): Observable<YearlyResource<SalaryTwoResponseDto>> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<YearlyResource<SalaryTwoResponseDto>>(
      `${this.apiUrl}/${companyId}/salary-two`,
      { params }
    );
  }

  updateSalaryTwo(companyId: string, request: SalaryTwoUpsertRequest): Observable<YearlyResource<SalaryTwoResponseDto>> {
    return this.http.put<YearlyResource<SalaryTwoResponseDto>>(`${this.apiUrl}/${companyId}/salary-two`, request);
  }
}
